export const BPD = 
{
    Metadata:{Name:'MSI-BPD',maxColumn:2,numRows:10},
    Sections:
    [
        {
            Headers:[
                "",
                "Yes",
                "No",
            ],
            Questions:[
                {
                    Prompt:"1. Have any of your closest relationships been troubled by a lot of arguments or repeated breakups?",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:0,Type:"radio"},
                    ]
                },
                {
                    Prompt:"2. Have you deliberately hurt yourself physically (e.g. punched yourself, cut yourself, burned yourself)? How about made a suicide attempt?",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:0,Type:"radio"},
                    ]
                },
                {
                    Prompt:"3. Have you had at least two other problems with impulsivity (e.g. eating binges and spending sprees, drinking too much and verbal outbursts?",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:0,Type:"radio"},
                    ]
                },
                {
                    Prompt:"4. Have you been extremely moody?",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:0,Type:"radio"},
                    ]
                },
                {
                    Prompt:"5. Have you often felt angry a lot of the time? How about often acted in an angry or sarcastic manner?",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:0,Type:"radio"},
                    ]
                },
                {
                    Prompt:"6. Have you often been distrustful of other people?",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:0,Type:"radio"},
                    ]
                },
                {
                    Prompt:"7. Have you frequently felt unreal or as if things around you were unreal?",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:0,Type:"radio"},
                    ]
                },
                {
                    Prompt:"8. Have you chronically felt empty?",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:0,Type:"radio"},
                    ]
                },
                {
                    Prompt:"9. Have you often felt that you had no idea of who you are or that you have no identity?",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:0,Type:"radio"},
                    ]
                },
                {
                    Prompt:"10. Have you made desperate efforts to avoid feeling abandoned (e.g. repeatedly called someone to reassure yourself that he or she still cared, begged them not to leave you, clung to them physically?",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:0,Type:"radio"},
                    ]
                },
            ]
        }
    ]
}